import * as React from "react"
import { ErrorPage, type ErrorPageProps } from "./ErrorPage"

export interface Error403Props extends Partial<Omit<ErrorPageProps, "code">> {
  /**
   * Custom illustration for the 403 page
   */
  illustration?: React.ReactNode
}

function Error403({
  title = "Access Denied",
  description = "You don't have permission to access this page. Please contact support if you believe this is an error.",
  illustration,
  ...props
}: Error403Props) {
  return (
    <ErrorPage
      code="403"
      title={title}
      description={description}
      illustration={illustration}
      {...props}
    />
  )
}

Error403.displayName = "Error403"

export { Error403 }
